// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2o4XX","inputDescription":"styles_inputDescription__vD3Jt"};